// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CheckboxStyle } from "@insite/mobius/Checkbox";
import { RadioStyle } from "@insite/mobius/Radio";
import { RadioGroupStyle } from "@insite/mobius/RadioGroup";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xCheckoutInnerContainerStyles } from "@pace/App/SharedStyles/CheckoutPageStyles";
import { checkoutReviewAndSubmitPaymentDetailsStyles } from "@pace/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import { color, mergeWithCss, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

checkoutReviewAndSubmitPaymentDetailsStyles.form = {
    css: css`
        padding-top: 24px;
        margin-top: 4px;
        border-top: 1px solid ${color("common.border")};
        display: block;
        width: 100%;
        float: left;
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentDetailsHeading = {
    variant: "h4",
    css: css`
        margin-bottom: 16px;
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodsOptionsContainer = {
    css: css`
        column-gap: 32px;
        align-items: center;
        margin-bottom: 24px;
        min-height: 56px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            align-items: flex-start;
            row-gap: 12px;
        }
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodsHeadingText = {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodsRadioGroup = {
    css: css`
        display: block;
        line-height: 1;
        > ${TypographyStyle} {
            margin: 0;
        }

        ${RadioStyle} {
            display: inline-block;
            margin-right: 32px;
            & + ${RadioStyle} {
                margin-top: 0;
            }

            &:last-of-type {
                margin-right: 0;
            }
        }
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.checkoutContainer = xCheckoutInnerContainerStyles.container;
checkoutReviewAndSubmitPaymentDetailsStyles.checkoutSection = xCheckoutInnerContainerStyles.section;
checkoutReviewAndSubmitPaymentDetailsStyles.checkoutTwoColumnsSection = xCheckoutInnerContainerStyles.sectionTwoColums;
checkoutReviewAndSubmitPaymentDetailsStyles.hr = mergeWithCss(xCheckoutInnerContainerStyles.hr, {
    css: css`
        margin: 24px 0;
    `,
});

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodSelectSection = mergeWithCss(
    xCheckoutInnerContainerStyles.sectionTwoColums,
    {
        css: css`
            align-items: flex-start;
            margin-bottom: 16px;

            ${CheckboxStyle} {
                margin-top: 32px;
            }
        `,
    },
);

checkoutReviewAndSubmitPaymentDetailsStyles.creditCardAddress = {
    useBillingAddressGridItem: {
        css: css`
            ${RadioGroupStyle} {
                > ${TypographyStyle} {
                    display: none;
                }
            }
        `,
    },
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentProfileBillingAddress = {
    label: {
        css: css`
            display: none;
        `,
    },
};
